import useCurriculumVariantB from "./use-mentorship-curriculum-variant-b";
import { MentorshipPlanTemplate } from "types/mentorship-plan";
import Topics from "./topics/topics";

type CurriculumVariantBProps = {
  mentorshipPlanDataCurriculam?: MentorshipPlanTemplate;
};

const MentorshipCurriculumVariantB = ({
  mentorshipPlanDataCurriculam,
}: CurriculumVariantBProps) => {
  const {
    curriculumStats,
    groupMentorTopicsBySubject,
    groupedTopicsLength,
    defaultAnalyticsPayload,
  } = useCurriculumVariantB({ mentorshipPlanDataCurriculam });

  return (
    <>
      <Topics
        curriculumStats={curriculumStats}
        groupedTopicsLength={groupedTopicsLength}
        groupMentorTopicsBySubject={groupMentorTopicsBySubject}
        defaultAnalyticsPayload={defaultAnalyticsPayload}
      />
    </>
  );
};

export default MentorshipCurriculumVariantB;
